module.exports = ".s-30{width:30px;height:30px;padding:6px}"